module.exports = __webpack_public_path__ + "static/media/pc-teams-background-pattern-2.c4af8bd2.svg";